import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUnlock = () => {
  return (
    <g>
      <path d="M12.002 0a4.009 4.009 0 0 1 3.993 3.81l.005.199V6.94a.75.75 0 0 1-1.493.102l-.007-.102V4.01a2.509 2.509 0 0 0-2.336-2.503L12 1.5a2.494 2.494 0 0 0-2.495 2.327l-.005.164v2.022l2.452.004c.54.001.985.41 1.042.936l.006.114v7.883c0 .541-.41.987-.936 1.044L11.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95v-7.9c0-.54.41-.986.936-1.043L1.05 6 8 6.011v-2.02A3.991 3.991 0 0 1 11.792.005l.21-.005zM1.5 7.501V14.5h10V7.516l-10-.015zM6.5 9a.75.75 0 0 1 .75.75v2.5a.75.75 0 1 1-1.5 0v-2.5A.75.75 0 0 1 6.5 9z" />
    </g>
  );
};

export default withIcon(IconUnlock);
